import React, { Component } from "react";
import { connect } from "react-redux";
import {
  captureBlobImages,
  addSluginToBlobImages,
} from "../../../action/extra_options/orderExtras.action.js";
import {
  commonConfirmationAlert,
  handleCloseforDoorWindows,
  DeviceCapture,
  handleShowPhotoModal,
} from "../../../action/index.js";
import AnimButton from "../../Button/AnimButton.js";

class DeviceCaptureInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowWarningTooltip: false,
    }
  }
  CheckCaptureImage = () => {
    this.props.handleCloseforDoorWindows(1);
    this.props.captureBlobImages("manual");
  };

  render() {
    let imageCount = 0;
    if (this.props.const_var.i_g_A_y.length > 0) {
      let checkImages = this.props.const_var.i_g_A_y.filter(
        (data) =>
          data.image_name != "2D Layout1" && data.image_name != "2D Layout"
      );
      imageCount = checkImages.length;
    }
    return (
      <>
        <div className="mobile-capture-wrapper" style={{paddingBottom: this.props.const_var.i_g_A_y.length > 0 && '14px' }}>
          <div className="mobile-capture-cta">
            <AnimButton
              isAnimation={false}
              className={'btn btn-default'}
              event={(e) =>

                this.props.const_var.i_g_A_y.length > 4
                  ? this.setState({isShowWarningTooltip: true})
                  : this.CheckCaptureImage()
              }
            >
              {" "}
              <span className="icon icon-capture-new"> </span>{" "}
              <span className="text">Capture</span>
              {this.props.const_var.i_g_A_y.length > 0 ? (
                <span className="photocount">{imageCount}</span>
              ) : null}
            </AnimButton>
            {
              this.state.isShowWarningTooltip &&
              <div className="warning-tooltip">
                Psst!! You can only click 5 photos. Please consider removing the OKish photo to click another best one.
                <i className="icon-close" onClick={() => this.setState({isShowWarningTooltip: false})}></i>
              </div>
            }
          </div>
          <div className="mobile-capture-bottom">
            <div className="mobile-capture-thumb">
              {this.props.const_var.i_g_A_y.length > 0 ? (
                <>
                  {Object.entries(this.props.const_var.i_g_A_y).map(
                    ([key, value]) => {
                      if (
                        value.image_name != "2D Layout" &&
                        value.image_name != "2D Layout1"
                      ) {
                        return (
                          <a
                            onClick={(e) =>
                              {
                                this.props.DeviceCapture(
                                  "redirect",
                                  `scrollid${key}`
                                )
                                this.props.handleShowPhotoModal();
                              }
                            }
                            key={key}
                          >
                            <span
                              onClick={(e) =>
                                this.props.addSluginToBlobImages(
                                  e,
                                  key,
                                  "",
                                  "CaptureMobile"
                                )
                              }
                              className={
                                this.props.const_var.i_g_A_y.length > 4
                                  ? "icon-close icon "
                                  : "icon-close icon "
                              }
                            ></span>
                            <span className="img-section">
                              {" "}
                              <img src={value.image} alt="3d Designer" />
                            </span>
                          </a>
                        );
                      }
                    }
                  )}
                </>
              ) : (
                <div className="no-images">
                  <span className="side-icon"></span>
                  <span className="side-icon"></span>
                  <span className="side-icon"></span>
                  <span className="side-icon"></span>
                  <p>
                    There are no building photos Captured.
                    If you wish to capture the photos.
                    "Set a great angle & zoom level on the screen and click capture"
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.orderExtrasReducer };
};

const mapDispatchToProps = {
  commonConfirmationAlert,
  handleCloseforDoorWindows,
  captureBlobImages,
  addSluginToBlobImages,
  DeviceCapture,
  handleShowPhotoModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceCaptureInfo);
